import { render, staticRenderFns } from "./ChamadoLista.vue?vue&type=template&id=427f60e4&scoped=true"
import script from "./ChamadoLista.vue?vue&type=script&lang=js"
export * from "./ChamadoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f60e4",
  null
  
)

export default component.exports